import klairOne from "./images/productImages/Klairs/1.jpg";
import klairTwo from "./images/productImages/Klairs/2.jpg";
import klairThree from "./images/productImages/Klairs/3.jpg";
import klairFour from "./images/productImages/Klairs/4.jpg";

import adropOne from "./images/productImages/adrop/1.jpg";
import adropTwo from "./images/productImages/adrop/2.jpg";
import adropThree from "./images/productImages/adrop/3.jpg";

import ratedGreenOne from "./images/productImages/RatedGreen/1.jpg";
import ratedGreenTwo from "./images/productImages/RatedGreen/2.jpg";

import byWishtrendOne from "./images/productImages/ByWishtrend/1.jpg";
import byWishtrendTwo from "./images/productImages/ByWishtrend/2.jpg";
import byWishtrendThree from "./images/productImages/ByWishtrend/3.jpg";

import suntiqueOne from "./images/productImages/Suntique/1.jpg";
import suntiqueTwo from "./images/productImages/Suntique/2.jpg";
import suntiqueThree from "./images/productImages/Suntique/3.jpg";

import haruharuwonderOne from "./images/productImages/haruharuwonder/1.jpg";
import haruharuwonderTwo from "./images/productImages/haruharuwonder/2.jpg";
import haruharuwonderThree from "./images/productImages/haruharuwonder/3.jpeg";
import haruharuwonderFour from "./images/productImages/haruharuwonder/4.jpg";

import klairsLogo from "./images/productLogos/Klairs.png";
import AdropLogo from "./images/productLogos/Adrop.png";
import haruharuLogo from "./images/productLogos/haruharuWonder.png";
import ratedGreenLogo from "./images/productLogos/RatedGreen.png";
import wishtrendLogo from "./images/productLogos/Wishtrend.png";
import suntiqueLogo from "./images/productLogos/Suntique.png";

import klairsBanner from "./images/productImages/Klairs/1.jpg";
import adropBanner from "./images/productImages/adrop/aDropbanner.jpeg";
import byWishtrendBanner from "./images/productImages/ByWishtrend/bannerWishtrend.png";
import haruBanner from "./images/productImages/haruharuwonder/haruBanner.jpeg";
import RatedgreenBanner from "./images/productImages/RatedGreen/ratedGreenBanner.jpeg";
import suntiqueBanner from "./images/productImages/Suntique/suntiqueBanner.jpeg";

export const productMap = [
  {
    name: "Klairs",
    pictures: [klairOne, klairTwo, klairThree, klairFour],
    banner: klairsBanner,
    instagram: "https://www.instagram.com/klairs.norge",
    facebook: "https://www.facebook.com/klairs.no/",
    productText: `
        Klairs er en koreansk hudpleieserie og produktene inneholder de viktigste
        ingrediensene fra rene råvarer, dvs. ingen farger, alkoholer, parabener
        eller parfymer. Alt for å gi en sunnere og sterkere hud, naturlig og
        effektivt. Produktene kommer i økologisk emballasje og ingen produkter
        er testet på dyr. Klairs er et vegansk og prisbelønnet merke, som ble
        grunnlagt i 2010, og har en sunn og ukomplisert tilnærming til hudpleie.
        <br />
        <br />
        Siden starten har Klairs spesialisert seg og fokusert sin forskning på
        ingredienser og råvarer for sensitiv hud. Produktene forbedrer ikke bare
        hudens elastisitet, men lindrer også irritert hud for å gjøre den
        naturlig sterk, frisk og elastisk.
        <br />
        <br />
        <b>“Simple but enough”</b>
        <br />
        <br />
        Klairs tilbyr alt fra rens og fuktgivning til beroligende og pleiende
        produkter. “Simple but enough” for huden din som påvirkes av
        værforandringer og livsstil.
        <br />
        <br />
        <b>“Basic but ultimate”</b>
        <br />
        <br />
        Klairs jobber hardt for å gi deg det beste innen hudpleie, slik at det
        skal være enkelt for deg å få en frisk og sunn hud.
        <br />
        <br />
        <b>“Mild but powerful”</b>
        <br />
        <br />
        Bak Klairs produkter ligger det mange år med forskning. Resultatet er
        en produktserie som gjenoppbygger huden, gir forbedret elastitet og roer
        ned irritert hud.
`,
  },
  //   {
  //     name: "adrop",
  //     pictures: [adropOne, adropTwo, adropThree],
  //     banner: adropBanner,
  //     instagram: "https://www.instagram.com/adrop/",
  //     facebook: "https://www.facebook.com/adropofficial/",
  //     productText: `
  //         adrop er vegansk, glutenfri hånddesinfeksjon på sprayflaske til å ha i
  //         lommen, bilen eller veska. adrop er fri for SLS og parabener uten at
  //         dette går på bekostning av desinfiseringen.
  //         <br />
  //         <br />
  //         Produktet er utviklet av to gründere i Tyskland som i likhet med mange
  //         andre, hadde sett seg lei av hånddesinfeksjon som renner, er klissete og
  //         ikke er særlig velluktende.
  //         <br />
  //         <br />
  //         «We rethink hand sanitizing»
  //         <br />
  //         <br />
  //         Flaskene kan refilles, er elegante i design (Red Dot design Award 2021)
  //         og behagelige å holde i hånden. Serien kommer med 5 ulike delikate
  //         dufter for enhver smak, uten at lukten henger ved lenge etter påføring.
  //         Sprayen gir fukt, uten å føles klissete og etterlater hendene
  //         fløyelsmyke.
  //         <br />
  //         <br />
  //         adrop er dermatologisk testet og er ikke testet på dyr. adrop setter av
  //         10 % av overskuddet til organisasjoner som jobber med å gi rent
  //         drikkevann og sanitæranlegg til mennesker som trenger det i samarbeid
  //         med Viva con Agua. I tillegg har de som mål å ha 100 % naturlige
  //         ingredienser og fullstendig bærekraftige emballasjeløsninger.
  //         <br />
  //         <br />
  //         «Spray love, not germs»
  //  `,
  //   },
  {
    name: "Rated Green",
    pictures: [ratedGreenOne, ratedGreenTwo],
    banner: RatedgreenBanner,
    instagram: "https://www.instagram.com/rated_green/",
    facebook: "https://www.facebook.com/profile.php?id=100057832942236",
    productText: `
        Rated Green er et koreansk hårpleiemerke, utviklet for å
        skjemme bort hår og hodebunn. Produktene er veganske, økologiske og fri
        for SLS og SLES.
        <br />
        <br />
        Rated Green har med sine produkter ønsket å redefinere naturlig
        hårpleie. Alle produktene inneholder organiske ingredienser og er
        Ecocert sertifisert. Flere av produktene er i tillegg Eve Vegan
        sertifisert som garanterer at produktene er veganske. For å hindre at
        viktige næringsstoffer forsvinner i utvinningsprosessen, lages Rated
        Green ved hjelp av kaldpressing og kaldbrygging. Produktene inneholder
        ingen skadelige ingredienser og er dermatologisk testet.
        <br />
        <br />
        Produktserien inneholder produkter for enhver hår- og hodebunnstype.
        Rated Green har fokus på at en sunn og god hodebunn gir et sunt og
        vakkert hår. De har derfor utviklet en rekke Scalp Paks som er en hår-
        og hodebunnskur som også gir pleie for håret, på lik linje med en
        balsam/hårkur. Rated Green har også utviklet hodebunnssprayer med
        kaldpresset rosmarin for å berolige tørr og irritert hodebunn, samt
        stimulere til økt hårvekst.
   `,
  },
  {
    name: "By Wishtrend",
    pictures: [byWishtrendOne, byWishtrendTwo, byWishtrendThree],
    banner: byWishtrendBanner,
    instagram: "https://www.instagram.com/bywishtrend.norge/",
    facebook: "https://www.facebook.com/profile.php?id=100063516938809",
    productText: `
        By Wishtrend er et koreansk hudpleiemerke hvor produktene inneholder
        enkle og aktive ingredienser som jevner ut hudtonen, øker fastheten og
        gir glød ved hjelp av høykonsentrert C- og E-vitamin og milde AHA-syrer.
        <br />
        <br />
        By Wishtrend er en serie som passer alle hudtyper, også sensitiv hud og
        problemhud. Produktene er enkle å bruke og de virkningsfulle
        ingrediensene gir maksimal effekt og en tydelig forbedret hud. Serien
        passer spesielt godt til deg som har problemer med akne, pigmentflekker,
        linjer, arr, rødhet og fet hud.
        <br />
        <br />
        Pure Vitamin C21,5 Advanced Serum var det første produktet By Wishtrend
        lanserte og siden den gang har By Wishtrend lansert flere innovative
        produkter. Hele serien er uten parabener, fenoxietanol, fargestoffer,
        syntetisk duft eller mineraloljer.
      `,
  },
  {
    name: "Suntique",
    pictures: [suntiqueOne, suntiqueTwo, suntiqueThree],
    banner: suntiqueBanner,
    instagram: "https://www.instagram.com/suntique_official/",
    facebook: "https://www.facebook.com/soel.no",
    productText: `
        Suntique er et koreansk hud- og hårpleiemerke som har spesialisert seg
        på individuelt tilpasset solbeskyttelse og trygge ingredienser. Suntique
        vet at ikke all hud er lik og har derfor laget solkremer og aftersun med
        dette i tankene!
        <br />
        <br />
        Suntique har solbeskyttelse for alle aldre, alle hudtyper, inkludert de
        med svært sensitiv hud. Varemerket har alt fra solkrem, solsticks,
        BB-cushion, serum, hårspray og aftersun! Her får du solkrem og
        fuktighetskrem i ett.
        <br />
        <br />
        SPF og PA- beskyttelse er en av de viktigste forebyggende
        hudpleieproduktene som finnes og like viktig hele året. Likevel vet vi
        at det kan være vanskelig å finne en god, ikke-irriterende solkrem for
        sensitiv hud. Mange solkremer for tørr hud er ikke fuktighetsgivende nok
        og legger seg som et tykt lag på huden eller gir masse white-cast. I
        tillegg opplever mange at solkrem fører til utslett og akne og at det er
        vanskelig å legge makeup over solkremen med ett fint resultat.
        <br />
        <br />
        Etter flere år med leting og testing har vi med Suntique, endelig funnet
        et solpleiemerke som beskytter og forebygger og som oppfyller alle våre
        krav, uten at dette går på bekostning av huden din!
        <br />
        <br />
        «Sun Lifeguard» - «Suncare A to Z»
      `,
  },
  {
    name: "Haruharu Wonder",
    pictures: [
      haruharuwonderOne,
      haruharuwonderTwo,
      haruharuwonderThree,
      haruharuwonderFour,
    ],
    banner: haruBanner,
    instagram: "https://www.instagram.com/haruharuwonder_official/",
    facebook: "https://www.facebook.com/official.Haruharu",
    productText: `
        Haruharu wonder er en livstilsren og vegansk hudpleieserie fra Sør-Korea
        med patentert fermentert svart ris og bark av bambusskudd. Med
        førsteklasses hudforsterkende ingredienser oppfyller Haruharu wonder
        dine daglig behov.
        <br />
        <br />
        Haruharu wonders visjon er å utvikle produkter som hjelper deg å gjøre
        et klokere og enklere valg. Haruharu wonders milde produkter inneholder
        naturlige, plantebaserte ingredienser med kliniske beviste fordeler. Med
        deres innovative bruk av fermenterte ingredienser, tar de til orde for
        at det finne bedre, bærekraftige løsninger, uten at dette går på
        bekostning av din hud.
        <br />
        <br />
        Haruharu wonders produkter er ett trygt valg for å oppnå en sunn og frisk
        hud, som gløder.
        <br />
        <br />
        Clean life, Clean beauty.
        <br />
        <br />
        Haruharu betyr hverdag på koreansk, og wonder er rett og slett
        forkortelsen av ordet wonderful. Med navnets nydelige betydning ønsker
        haruharu wonder å være en del av din hverdagsrutine.
      `,
  },
];

export const outletData = {
  brands: [
    {
      name: "Klairs",
      logo: klairsLogo,
      countries: {
        norway: {
          urls: [
            "http://www.vitusapotek.no",
            "http://www.youty.no",
            "http://www.blush.no",
            "http://www.eleven.no",
            "http://www.nordicfeel.no",
            "http://www.apotera.no",
            "http://www.farmasiet.no",
            "http://www.coverbrands.no",
            "http://www.vita.no",
            "http://www.iglow.no",
            "http://www.blivakker.no",
            "http://www.thatglow.no",
            "http://www.sincere.no",
          ],
        },
        sweden: {
          urls: [
            "http://www.youty.se",
            "http://www.eleven.se",
            "http://www.nordicfeel.se",
            "http://www.cocopanda.se",
          ],
        },
        denmark: {
          urls: ["http://www.youty.dk", "http://www.cocopanda.dk"],
        },
        finland: {
          urls: [
            "http://www.youty.fi",
            "http://www.nordicfeel.fi",
            "http://www.eleven.fi",
            "http://www.cocopanda.fi",
          ],
        },
      },
    },
    {
      name: "By Wishtrend",
      logo: wishtrendLogo,
      countries: {
        norway: {
          urls: [
            "http://www.youty.no",
            "http://www.blush.no",
            "http://www.eleven.no",
            "http://www.nordicfeel.no",
            "http://www.apotera.no",
            "http://www.farmasiet.no",
            "http://www.coverbrands.no",
            "http://www.vita.no",
            "http://www.iglow.no",
            "http://www.blivakker.no",
            "http://www.thatglow.no",
            "http://www.sincere.no",
          ],
        },
        sweden: {
          urls: [
            "http://www.youty.se",
            "http://www.eleven.se",
            "http://www.nordicfeel.se",
            "http://www.cocopanda.se",
          ],
        },
        denmark: {
          urls: ["http://www.youty.dk", "http://www.cocopanda.dk"],
        },
        finland: {
          urls: [
            "http://www.youty.fi",
            "http://www.nordicfeel.fi",
            "http://www.eleven.fi",
            "http://www.cocopanda.fi",
          ],
        },
      },
    },
    {
      name: "Suntique",
      logo: suntiqueLogo,
      countries: {
        norway: {
          urls: [
            "http://www.youty.no",
            "http://www.blush.no",
            "http://www.eleven.no",
            "http://www.nordicfeel.no",
            "http://www.apotera.no",
            "http://www.farmasiet.no",
            "http://www.coverbrands.no",
            "http://www.vita.no",
            "http://www.blivakker.no",
            "http://www.thatglow.no",
            "http://www.lyko.com",
            "http://www.sincere.no",
          ],
        },
        sweden: {
          urls: [
            "http://www.youty.se",
            "http://www.eleven.se",
            "http://www.nordicfeel.se",
            "http://www.cocopanda.se",
            "http://www.lyko.com",
          ],
        },
        denmark: {
          urls: [
            "http://www.youty.dk",
            "http://www.cocopanda.dk",
            "http://www.lyko.com",
          ],
        },
        finland: {
          urls: [
            "http://www.youty.fi",
            "http://www.nordicfeel.fi",
            "http://www.eleven.fi",
            "http://www.cocopanda.fi",
            "http://www.lyko.com",
          ],
        },
        austria: {
          urls: ["http://www.lyko.com"],
        },
        poland: {
          urls: ["http://www.lyko.com"],
        },
        germany: {
          urls: ["http://www.lyko.com"],
        },
      },
    },
    {
      name: "Rated Green",
      logo: ratedGreenLogo,
      countries: {
        norway: {
          urls: [
            "http://www.youty.no",
            "http://www.blush.no",
            "http://www.eleven.no",
            "http://www.nordicfeel.no",
            "http://www.apotera.no",
            "http://www.farmasiet.no",
            "http://www.coverbrands.no",
            "http://www.vita.no",
            "http://www.lyko.com",
          ],
        },
        sweden: {
          urls: [
            "http://www.youty.se",
            "http://www.eleven.se",
            "http://www.nordicfeel.se",
            "http://www.lyko.com",
          ],
        },
        denmark: {
          urls: [
            "http://www.youty.dk",
            "http://www.cocopanda.dk",
            "http://www.lyko.com",
          ],
        },
        finland: {
          urls: [
            "http://www.youty.fi",
            "http://www.nordicfeel.fi",
            "http://www.eleven.fi",
            "http://www.cocopanda.fi",
            "http://www.lyko.com",
          ],
        },
        austria: {
          urls: ["http://www.lyko.com"],
        },
        poland: {
          urls: ["http://www.lyko.com"],
        },
        germany: {
          urls: ["http://www.lyko.com"],
        },
      },
    },
    {
      name: "Haruharu Wonder",
      logo: haruharuLogo,
      countries: {
        norway: {
          urls: [
            "http://www.apotek1.no",
            "http://www.lyko.com",
            "http://www.farmasiet.no",
            "http://www.apotera.no",
            "http://www.sincere.no",
          ],
        },
        denmark: {
          urls: ["http://www.lyko.com"],
        },
        finland: {
          urls: ["http://www.lyko.com"],
        },
        austria: {
          urls: ["http://www.lyko.com"],
        },
        poland: {
          urls: ["http://www.lyko.com"],
        },
        germany: {
          urls: ["http://www.lyko.com"],
        },
      },
    },
    // {
    //   name: "adrop",
    //   logo: AdropLogo,
    //   countries: {
    //     norway: {
    //       urls: [
    //         "http://www.blush.no",
    //         "http://www.youty.no",
    //         "http://www.elven.no",
    //         "http://www.nordicfeel.no",
    //         "http://www.lyko.com",
    //       ],
    //     },
    //     denmark: {
    //       urls: ["http://www.youty.dk", "http://www.lyko.com"],
    //     },
    //     finland: {
    //       urls: [
    //         "http://www.youty.fi",
    //         "http://www.nordicfeel.fi",
    //         "http://www.eleven.fi",
    //         "http://www.cocopanda.fi",
    //         "http://www.lyko.com",
    //       ],
    //     },
    //     austria: {
    //       urls: ["http://www.lyko.com"],
    //     },
    //     poland: {
    //       urls: ["http://www.lyko.com"],
    //     },
    //     germany: {
    //       urls: ["http://www.lyko.com"],
    //     },
    //   },
    // },
  ],
};
